import { render, staticRenderFns } from "./BasketWidget.vue?vue&type=template&id=4da9628e&scoped=true&"
import script from "./BasketWidget.vue?vue&type=script&lang=js&"
export * from "./BasketWidget.vue?vue&type=script&lang=js&"
import style0 from "./BasketWidget.vue?vue&type=style&index=0&id=4da9628e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da9628e",
  null
  
)

export default component.exports